<template>
	<div
		v-testid="'notification-toast'"
		role="status"
		aria-live="polite"
		:class="$style['notification-toast']"
		@mouseenter="isPaused = true"
		@mouseleave="isPaused = false"
		@focusin="isPaused = true"
		@focusout="isPaused = false"
	>
		<Notification
			:notification="notification"
			in-toast
			@close="$emit('close', $event)"
			@action="$emit('action', $event)"
			@success="$emit('success', $event)"
			@delete="$emit('delete', $event)"
		/>
		<NotificationProgressBar
			:duration="duration"
			:paused="isPaused"
			@end="$emit('close', notification)"
		/>
	</div>
</template>

<script>
import Notification from './Notification'
import NotificationProgressBar from './NotificationProgressBar'

export default {
	name: 'NotificationToast',
	components: {
		Notification,
		NotificationProgressBar
	},
	props: {
		notification: {
			type: Object,
			required: true
		},
		duration: {
			type: Number,
			default: 5000
		}
	},
	data () {
		return {
			isPaused: false
		}
	}
}
</script>

<style lang="scss" module>
.notification-toast {
    width: 340px;
    max-width: calc(100vw - #{$gutter * 4});
    overflow: hidden;
    border-radius: 8px;
    background-color: getColor(surface-elevated);
    color: getColor(text);
    box-shadow: 0 4px 12px rgb(0 0 0 / 0.15);
    transition: opacity 0.3s ease-out, transform 0.3s ease-out, box-shadow 0.3s ease-out;
}
</style>
